import React, { useState } from 'react';
import { authClient } from '../amplifyConfig';
import { RichTextarea, RichText } from './RichText';

function ContentSection({ type, items, setItems, featured, setFeatured, isAdmin, onCardClick }) {
  const [showCreate, setShowCreate] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [selectedItem, setSelectedItem] = useState(null);

  const model = type === 'poetry' ? authClient.models.Poetry : authClient.models.Blog;
  const label = type === 'poetry' ? 'Poem' : 'Post';
  const labelPlural = type === 'poetry' ? 'Poems' : 'Posts';

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      const res = await model.create({
        title,
        content,
        date: new Date().toLocaleDateString(),
        isFeatured: items.length === 0,
      });
      const created = res.data;
      setItems(prev => [created, ...prev]);
      if (!featured) setFeatured(created);
      setTitle('');
      setContent('');
      setShowCreate(false);
    } catch (err) {
      console.error('Create failed:', err);
    }
  };

  const handleSetFeatured = async (item, e) => {
    e.stopPropagation();
    try {
      if (featured) await model.update({ id: featured.id, isFeatured: false });
      await model.update({ id: item.id, isFeatured: true });
      setItems(prev => prev.map(i => ({ ...i, isFeatured: i.id === item.id })));
      setFeatured({ ...item, isFeatured: true });
      setSelectedItem({ ...item, isFeatured: true });
    } catch (err) {
      console.error('Set featured failed:', err);
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm('Delete this item?')) return;
    try {
      await model.delete({ id });
      setItems(prev => prev.filter(i => i.id !== id));
      if (featured?.id === id) setFeatured(null);
      if (selectedItem?.id === id) setSelectedItem(null);
    } catch (err) {
      console.error('Delete failed:', err);
    }
  };

  const displayItem = selectedItem || featured;

  return (
    <>
      {displayItem && (
        <div className="featured-tile">
          <p className="featured-label">Featured {label}</p>
          <h2>{displayItem.title}</h2>
          <p className="content-date">{displayItem.date}</p>
          <div className="content-body"><RichText content={displayItem.content} /></div>
        </div>
      )}

      {isAdmin && (
        <button className="upload-btn" onClick={() => setShowCreate(!showCreate)}>
          {showCreate ? 'Cancel' : `+ New ${label}`}
        </button>
      )}

      {showCreate && (
        <div className="upload-form">
          <h3>New {label}</h3>
          <form onSubmit={handleCreate}>
            <input
              type="text"
              placeholder="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
            <RichTextarea
              placeholder={type === 'poetry' ? 'Write your poem...' : 'Write your post...'}
              value={content}
              onChange={setContent}
            />
            <div className="form-actions">
              <button type="submit">Publish</button>
              <button type="button" onClick={() => setShowCreate(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <p className="section-heading">All {labelPlural}</p>
      <div className="card-grid">
        {items.map(item => (
          <div key={item.id} className="card" onClick={() => { setSelectedItem(item); onCardClick && onCardClick(item); }}>
            <div className="card-body">
              <p className="card-title">{item.title}</p>
              <p className="card-date">{item.date}</p>
              <p className="card-preview">{item.content.substring(0, 120)}…</p>
              {isAdmin && (
                <div className="card-actions">
                  <button className="btn-feature" onClick={(e) => handleSetFeatured(item, e)}>Feature</button>
                  <button className="btn-delete" onClick={(e) => handleDelete(item.id, e)}>Delete</button>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default ContentSection;
